import { REHYDRATE } from 'redux-persist/lib/constants';

const initial = {
  recent: []
};

// reducers
export default function recentlyViewed(state = initial, action) {
  switch (action.type) {
    case 'PUT_RECENT_PRODUCTS': {
      return {
        ...state,
        recent: [...state.recent, action.recent]
      };
    }

    case 'FETCH_RECENT_PRODUCTS':
      const { payload = {} } = action;
      const { recentlyViewed = {} } = payload;
      const { recent = [] } = recentlyViewed;
      const nextState = {
        ...state,
        recent: [...recent, ...state.recent]
      };
      nextState.recent = nextState.recent.filter((id, index, array) => array.indexOf(id) === index);
      if (nextState.recent.length > 11) {
        nextState.recent.shift();
      }
      return {
        ...nextState
      };

    default:
      return state;
  }
}
